import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'translate',
    standalone: false
})
export class TranslateMockPipe implements PipeTransform {
    transform(key: string, languageCode?: string): string {
        return key;
    }
}
